// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__d_FvC","containerItemsCenter":"Skeleton_containerItemsCenter__dNKM1"};